// src/data.js

export const menuData = [
    // --- DÖNERLER ---
    {
      id: 1,
      name: "Et Döner Dürüm",
      description: "120gr yaprak et döner, lavaş, soğan, domates, özel sos",
      price: 240,
      category: "Dönerler",
      // Yeni ve çalışan görsel:
      image: "https://images.unsplash.com/photo-1644364935906-88b63ce03977?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 2,
      name: "Tavuk Döner Dürüm",
      description: "110gr tavuk döner, turşu, patates kızartması, sarımsaklı mayonez",
      price: 150,
      category: "Dönerler",
      image: "https://images.unsplash.com/photo-1635528096183-1b77eb86e426?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 3,
      name: "Tombik Et Döner",
      description: "Taş fırın tombik ekmek, 130gr et döner, yeşillik",
      price: 260,
      category: "Dönerler",
      image: "https://images.unsplash.com/photo-1626700051175-6818013e1d4f?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 4,
      name: "İskender Kebap",
      description: "Tereyağlı sos, tava yoğurdu, ızgara domates ve biber ile",
      price: 380,
      category: "Kebaplar",
      image: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 5,
      name: "Pilav Üstü Et Döner",
      description: "Tereyağlı pirinç pilavı üzerinde 150gr et döner",
      price: 360,
      category: "Kebaplar",
      image: "https://images.unsplash.com/photo-1652545083457-37c22502660d?q=80&w=600&auto=format&fit=crop"
    },

    // --- YAN ÜRÜNLER (SepetTakip tarzı eklemeler) ---
    {
      id: 6,
      name: "Mercimek Çorbası",
      description: "Süzme mercimek, kıtır ekmek ve limon ile",
      price: 70,
      category: "Çorbalar",
      image: "https://images.unsplash.com/photo-1547592166-23acbe346499?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 7,
      name: "Patates Kızartması",
      description: "Parmak patates, özel baharatlı",
      price: 80,
      category: "Yan Ürünler",
      image: "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?q=80&w=600&auto=format&fit=crop"
    },

    // --- İÇECEKLER ---
    {
      id: 8,
      name: "Yayık Ayran",
      description: "Bakır kupa ile servis edilir, bol köpüklü",
      price: 40,
      category: "İçecekler",
      image: "https://images.unsplash.com/photo-1626132647523-66f5bf380027?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 9,
      name: "Kutu Kola",
      description: "330ml orijinal tat",
      price: 50,
      category: "İçecekler",
      image: "https://images.unsplash.com/photo-1622483767028-3f66f32aef97?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 10,
      name: "Şalgam Suyu",
      description: "Acılı / Acısız seçenekleri ile",
      price: 45,
      category: "İçecekler",
      image: "https://images.unsplash.com/photo-1672323789505-1a2214316827?q=80&w=600&auto=format&fit=crop"
    },

    // --- TATLILAR ---
    {
      id: 11,
      name: "Fırın Sütlaç",
      description: "Üzeri nar gibi kızarmış, bol fındıklı",
      price: 90,
      category: "Tatlılar",
      image: "https://images.unsplash.com/photo-1623687398363-23df46490800?q=80&w=600&auto=format&fit=crop"
    },
    {
      id: 12,
      name: "Künefe",
      description: "Hatay usulü, sıcak şerbetli",
      price: 180,
      category: "Tatlılar",
      image: "https://images.unsplash.com/photo-1576082987829-23f272c7221e?q=80&w=600&auto=format&fit=crop"
    }
  ];